// import { paginationDataToShow } from "../actions/generalActions";
import {
  ITEM_CREATE_REQUEST,
  ITEM_CREATE_SUCCESS,
  ITEM_CREATE_FAIL,
  ALL_ITEM_VIEW_REQUEST,
  ALL_ITEM_VIEW_SUCCESS,
  ALL_ITEM_VIEW_FAIL,
  ITEM_UPDATE_REQUEST,
  ITEM_UPDATE_SUCCESS,
  ITEM_UPDATE_FAIL,
  ITEMS_BY_ID_SUCCESS,
} from "../constants";

export const itemReducer = (
  state = {
    items: {
      items: null,
      from: null,
      to: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case ITEM_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ITEM_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ITEM_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ITEM VIEW TABLE
    case ALL_ITEM_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_ITEM_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };
    case ALL_ITEM_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // ITEM UPDATE
    case ITEM_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ITEM_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        items: state.items.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case ITEM_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ITEMS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        itemsDetails: action.payload,
      };

    default:
      return state;
  }
};
